import { render } from "./BuyFamilyComponent.vue?vue&type=template&id=6f3cbaef&ts=true"
import script from "./BuyFamilyComponent?vue&type=script&lang=ts"
export * from "./BuyFamilyComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__